import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericResponseDTO } from '@app/auth/interfaces';
import { OperacionDTO } from '@app/entidades/operacion.model';
import {
  OperacionesFilter,
  RespuestaGenerica,
} from '@app/entidades/ordenes.model';
import { environment } from '@env';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OperacionService {
  private baseUrl = environment.apiResrURL;
  private operacionesUrl = `${this.baseUrl}/sgi-operaciones`;
  private ordenesUrl = `${this.baseUrl}/sgi-ordenes`;

  constructor(private http: HttpClient) {}

  // public enviarOperacion(operacion: any): Observable<any> {
  //   return this.http.post<GenericResponseDTO>(
  //     `${this.operacionesUrl}/`,
  //     operacion,
  //   );
  // }

  // public filtrarOperaciones(data: any): Observable<any> {
  //   return this.http.post<GenericResponseDTO>(
  //     `${this.operacionesUrl}/filtrar`,
  //     data,
  //   );
  // }

  // public consultarOperacion(id: string | number): Observable<any> {
  //   return this.http.get<GenericResponseDTO>(
  //     `${this.operacionesUrl}/get?id=${id}`,
  //   );
  // }

  public enviarOperacionNuevo(operacion: OperacionDTO): Observable<any> {
    return this.http.post<GenericResponseDTO>(`${this.ordenesUrl}/ordenes/ecommerce/nueva`, operacion);
  }

  public async traerOrden(id: any): Promise<GenericResponseDTO> {
    return firstValueFrom(
      this.http.get<GenericResponseDTO>(`${this.ordenesUrl}/ordenes/${id}`),
    );
  }

  public async filtrarOperacionesAsync(
    data: OperacionesFilter,
  ): Promise<RespuestaGenerica> {
    return firstValueFrom(
      this.http.post<RespuestaGenerica>(
        `${this.ordenesUrl}/ordenes/buscar`,
        data,
      ),
    );
  }
}
